'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z' });

var ReportProblem = function ReportProblem(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

ReportProblem = (0, _pure2.default)(ReportProblem);
ReportProblem.muiName = 'SvgIcon';

exports.default = ReportProblem;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/ReportProblem.js
// module id = 2777
// module chunks = 0